<script lang="ts">
import { type Component } from 'vue'
import {
  IconSocialEmail,
  IconUserGeneralOutline,
  IconDeviceSmartphone,
  IconGeneralOfficeBuilding,
  IconGeneralChatBubble,
  IconObjectTag,
  type WindiColor,
} from '@cypress-design/vue-icon'

export const Icons: Record<string, Component> = {
  default: IconObjectTag,
  tag: IconObjectTag,
  email: IconSocialEmail,
  user: IconUserGeneralOutline,
  smartphone: IconDeviceSmartphone,
  building: IconGeneralOfficeBuilding,
  chat: IconGeneralChatBubble,
}

export type IconKey = keyof typeof Icons
</script>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
  type: IconKey
  fillColor?: WindiColor
  strokeColor?: WindiColor
}>()

const Icon = computed(() => {
  return Icons[props.type]
})
</script>

<template>
  <Icon v-bind="{ fillColor, strokeColor }" />
</template>
